import { getSessionToken } from '@shopify/app-bridge-utils';
import axios from 'axios';

const client = axios.create();

client.interceptors.request.use(async (config) => {
    const token = await getSessionToken(window.app);
    config.headers.Authorization = `Bearer ${token}`;

    return config;
});

const Api = {
    getCustomers: (page, perPage) => client.get('/api/customers', {
        params: {
            page,
            per_page: perPage,
        }
    }),

    getReports: () => client.get('/api/reports'),

    getOrderReports: () => client.get('/api/reports/orders'),
}

export default Api;
